// Combined action types for both user dashboard and breadcrumbs
export const DASHBOARD_ACTIONS = {
  // User menu actions (for breadcrumbs)
  FETCH_USER_MENU_REQUEST: 'FETCH_USER_MENU_REQUEST',
  FETCH_USER_MENU_SUCCESS: 'FETCH_USER_MENU_SUCCESS',
  FETCH_USER_MENU_FAILURE: 'FETCH_USER_MENU_FAILURE',

  // Dashboard data actions (for user dashboard page)
  FETCH_DASHBOARD_REQUEST: 'FETCH_DASHBOARD_REQUEST',
  FETCH_DASHBOARD_SUCCESS: 'FETCH_DASHBOARD_SUCCESS',
  FETCH_DASHBOARD_FAILURE: 'FETCH_DASHBOARD_FAILURE',

  // Notification actions
  MARK_NOTIFICATION_READ_REQUEST: 'MARK_NOTIFICATION_READ_REQUEST',
  MARK_NOTIFICATION_READ_SUCCESS: 'MARK_NOTIFICATION_READ_SUCCESS',
  MARK_NOTIFICATION_READ_FAILURE: 'MARK_NOTIFICATION_READ_FAILURE',

  // Invitation actions
  ACCEPT_INVITATION_REQUEST: 'ACCEPT_INVITATION_REQUEST',
  ACCEPT_INVITATION_SUCCESS: 'ACCEPT_INVITATION_SUCCESS',
  ACCEPT_INVITATION_FAILURE: 'ACCEPT_INVITATION_FAILURE',
  REJECT_INVITATION_REQUEST: 'REJECT_INVITATION_REQUEST',
  REJECT_INVITATION_SUCCESS: 'REJECT_INVITATION_SUCCESS',
  REJECT_INVITATION_FAILURE: 'REJECT_INVITATION_FAILURE',
};

// The Calendar Month V2 bootstrap thunk fetches the SAME `/org/{unique}/dashboard`
// payload this reducer holds, and shares its `userMenu` + `organizationSettings`
// so the breadcrumb doesn't refetch. Matched by the literal createAsyncThunk type
// `calendarMonthBootstrap/fetch/fulfilled` (NOT an import — keeps this global,
// 19-page reducer decoupled from the calendar-only bootstrap slice so the slice
// isn't pulled into every page's bundle).
const CALENDAR_BOOTSTRAP_FULFILLED = 'calendarMonthBootstrap/fetch/fulfilled';

const initialState = {
  // For breadcrumbs
  userMenu: [],
  organizationSettings: null,

  // For user dashboard
  profile: null,
  organizations: [],
  agenda: [],
  notifications: [],
  invitations: [],

  // Common loading/error states
  loading: false,
  isLoading: false,
  error: null
};

export default function DashboardReducer(state = initialState, action) {
  switch (action.type) {
    // User menu actions (for breadcrumbs)
    case DASHBOARD_ACTIONS.FETCH_USER_MENU_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case DASHBOARD_ACTIONS.FETCH_USER_MENU_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userMenu: action.payload.userMenu,
        organizationSettings: action.payload.organizationSettings
      };

    case DASHBOARD_ACTIONS.FETCH_USER_MENU_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };

    // Calendar Month V2 bootstrap shares its dashboard payload here so the
    // breadcrumb renders the menu without its own fetch. Only overwrite when
    // the bootstrap actually carried a menu (avoid clobbering with an empty
    // list); organizationSettings drives the Training item gating.
    case CALENDAR_BOOTSTRAP_FULFILLED:
      return {
        ...state,
        isLoading: false,
        ...(Array.isArray(action.payload?.userMenu) && action.payload.userMenu.length > 0
          ? { userMenu: action.payload.userMenu }
          : {}),
        ...(action.payload?.organizationSettings
          ? { organizationSettings: action.payload.organizationSettings }
          : {})
      };

    // Dashboard data actions (for user dashboard page)
    case DASHBOARD_ACTIONS.FETCH_DASHBOARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DASHBOARD_ACTIONS.FETCH_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        ...(action.payload.profile && { profile: action.payload.profile }),
        ...(action.payload.organizations && { organizations: action.payload.organizations }),
        ...(action.payload.agenda && { agenda: action.payload.agenda }),
        ...(action.payload.notifications && { notifications: action.payload.notifications }),
        ...(action.payload.invitations && { invitations: action.payload.invitations })
      };

    case DASHBOARD_ACTIONS.FETCH_DASHBOARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    // Notification actions
    case DASHBOARD_ACTIONS.MARK_NOTIFICATION_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map(notification =>
          notification.id === action.payload.notificationId
            ? { ...notification, read: true }
            : notification
        )
      };

    // Invitation actions
    case DASHBOARD_ACTIONS.ACCEPT_INVITATION_SUCCESS:
      return {
        ...state,
        invitations: state.invitations.filter(
          inv => inv.organizationUnique !== action.payload.organizationUnique
        )
      };

    case DASHBOARD_ACTIONS.REJECT_INVITATION_SUCCESS:
      return {
        ...state,
        invitations: state.invitations.filter(
          inv => inv.organizationUnique !== action.payload.organizationUnique
        )
      };

    default:
      return state;
  }
}
